export default __webpack_public_path__ + "static/galaxy-1fae27cb75036c980b3220a75a9d22e4.png";